import React, { Component } from "react"
import { connect } from "react-redux"
import Menu from "components/menu"
import PROVIDER_CONFIG from "./provider_config"

class Vaccinations extends Component {
  render() {
    return <Menu {...PROVIDER_CONFIG} {...this.props} />
  }
}

const mapStateToProps = (state) => {
  return {
    providerContact: { _id: state.reducers.pets.selectedPet._user },
    messages: state.intl.messages.containers.features.vaccinations,
    vacs: state.reducers.vacs,
  }
}

export default connect(mapStateToProps)(Vaccinations)
